<template>
  <div>
    <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <span :class="{ 'loading-card': loading.card }"
              ><strong>Detail Deposit</strong></span
            >
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <div :class="{ 'loading-card': loading.card }">
                  <dt>Waktu Masuk & Update</dt>
                  <dd>
                    {{ deposit.created_at }}<br />{{ deposit.updated_at }}
                  </dd>

                  <dt>ID Deposit</dt>
                  <dd>#{{ deposit.id }}</dd>

                  <dt>Metode Pembayaran</dt>
                  <dd>
                    <b>{{ deposit.payment.payment_name }}</b> -
                    {{ deposit.payment_number }}<br />Atas Nama :
                    {{ deposit.payment.payment_owner }}
                  </dd>
                </div>
              </CCol>
              <CCol sm="6">
                <div :class="{ 'loading-card': loading.card }">
                  <dt>Jml. Credit</dt>
                  <dd>{{ deposit.credit | rupiah }}</dd>

                  <dt>Nominal Transfer</dt>
                  <dd>Rp {{ deposit.nominal_transfer | rupiah }}</dd>

                  <dt>Waktu Expired</dt>
                  <dd>{{ deposit.expired_time }}</dd>

                  <dt>Status</dt>
                  <dd>
                    <CBadge color="warning" v-if="deposit.status == 'WAITING'"
                      >Menunggu</CBadge
                    >
                    <CBadge
                      color="success"
                      v-else-if="deposit.status == 'SUCCESS'"
                      >Berhasil</CBadge
                    >
                    <CBadge
                      color="danger"
                      v-else-if="deposit.status == 'EXPIRED'"
                      >Expired</CBadge
                    >
                  </dd>
                </div>
              </CCol>
            </CRow>
            <CAlert
              show
              color="info"
              class="mt-3"
              :class="{ 'loading-card': loading.card }"
              v-if="deposit.qr_url != null"
            >
              <small>
                Silahkan Scan QR Code dibawah ini melalui Aplikasi yang support
                pembayaran QRIS
              </small>
            </CAlert>
            <div class="row" v-if="deposit.qr_url != null">
              <div class="col-12 text-center">
                <img :src="deposit.qr_url" width="100%" />
              </div>
            </div>
            <CAlert
              show
              color="danger"
              class="mt-3"
              :class="{ 'loading-card': loading.card }"
              v-if="deposit.status == 'WAITING'"
            >
              <small>
                Mohon diperhatikan nominal transfer dan waktu expired, pastikan
                Anda melakukan transfer sesuai nominal yang tertera tanpa
                mengurangi atau membulatkan nominal, serta mohon untuk
                memperhatikan batas waktu melakukan pembayaran.
                <br /><b
                  >Kesalahan nominal transfer akan diproses lebih lama dari
                  waktu normal.</b
                >
              </small>
            </CAlert>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from "vuex";
import $axios from "./../../../api.js";
export default {
  name: "history.deposit.show",
  data() {
    return {
      alert: {
        show: false,
        content: "",
      },
      loading: {
        submit: false,
        card: true,
      },
      deposit: {
        payment: {},
      },
    };
  },
  created() {},
  computed: {
    ...mapState(["setting", "errors"]),
  },
  methods: {
    getDeposit(id) {
      $axios
        .get("/history/deposit/" + id)
        .then((response) => {
          this.loading.card = false;
          this.deposit = response.data.data;
        })
        .catch((error) => {
          this.loading.card = false;
        });
    },
  },
  mounted() {
    this.getDeposit(this.$route.params.id);
  },
};
</script>
